import Config from '../config/config'
import util from './util'
import md5 from 'js-md5';

export default {
  // 星辰签名
  sign(data) {
    var jsonStr = util.jsonSort(data)
    var strTmp = jsonStr + '&key=' + Config.xcAppSecretKey
    var res = md5(strTmp).toUpperCase()
    console.log(res)
    return res
  }
}



// WEBPACK FOOTER //
// ./src/util/sign.js